import { FC } from 'react';
import s from './AddTagsModal.module.scss';
import { Title } from '@tremor/react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod/dist/zod';
import { GeneralModalProps } from '@/types/modals';
import { ModalWrapper } from '../ModalWrapper/ModalWrapper';
import { tagSchema, TagSchema } from '@/utils/schemas';
import { ModalBottomActions } from '../ModalBottomActions/ModalBottomActions';
import { TagsService } from '@/services/dataforseo/tagsService';
import { useWorkspaceIdFromParams } from '@/hooks/useWorkspaceIdFromParams';
import { useUserPermissionsStore } from '@/stores/userPermissionsStore';
import { useRevalidator } from 'react-router-dom';

type Props = GeneralModalProps;

export const AddTagsModal: FC<Props> = ({ isOpen, setClose }) => {
  return (
    <ModalWrapper className={s.modalContainer} isOpen={isOpen} onRequestClose={setClose}>
      <AddTagsModalContent setClose={setClose} />
    </ModalWrapper>
  );
};

type ContentProps = Pick<Props, 'setClose'>;

const AddTagsModalContent: FC<ContentProps> = ({ setClose }) => {
  const workspaceId = useWorkspaceIdFromParams() as string;
  const revalidator = useRevalidator();
  const userId = useUserPermissionsStore((state) => state.userId) as string;
  const { handleSubmit, register } = useForm<TagSchema>({
    resolver: zodResolver(tagSchema),
    defaultValues: { tags: '' },
  });

  const onSubmit = async (data: TagSchema) => {
    await TagsService.createTags(data.tags, workspaceId, userId, 'dataforseo');
    revalidator.revalidate();
    setClose();
  };

  return (
    <>
      <section className={s.titleContainer}>
        <Title>Add Tags</Title>
      </section>
      <form className={s.form} onSubmit={handleSubmit(onSubmit)}>
        <textarea
          className={s.textarea}
          placeholder="Enter tag one per line or separated by commas"
          {...register('tags')}
        />
        <ModalBottomActions setClose={setClose} acceptLabel="Add" isLoading={false} />
      </form>
    </>
  );
};
